import { render, staticRenderFns } from "./ReferenceImage.vue?vue&type=template&id=5fcaf0ea&scoped=true&"
import script from "./ReferenceImage.vue?vue&type=script&lang=js&"
export * from "./ReferenceImage.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceImage.vue?vue&type=style&index=0&id=5fcaf0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcaf0ea",
  null
  
)

export default component.exports